var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "portal",
    {
      attrs: {
        to: "popover",
        disabled: _vm.disablePortal,
        slim: _vm.slim ? true : undefined
      }
    },
    [
      _vm.visibleActive
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "move",
                  rawName: "v-move",
                  value: _vm.container,
                  expression: "container"
                }
              ],
              ref: "popoverContainer",
              class: [
                "popover",
                ..._vm.positionClassList,
                ..._vm.stateClassList,
                _vm.hasCloseBtn && "has-close-btn"
              ],
              style: { maxWidth: _vm.maxWidth, "z-index": _vm.zIndex },
              attrs: { "data-testid": "popover" }
            },
            [
              _vm.showHeader
                ? _c(
                    "header",
                    {
                      staticClass: "popover__title-container",
                      attrs: { "data-testid": "header" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "popover__title" },
                        [
                          _vm._t("popoverTitle", function() {
                            return [
                              _vm.state
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "popover__title-icon",
                                      attrs: { "data-testid": "title-icon" }
                                    },
                                    [
                                      _c("i", {
                                        class: [
                                          "icon",
                                          _vm.state === "negative" &&
                                            "icon-warning",
                                          _vm.state === "warning" &&
                                            "icon-warning-01",
                                          _vm.state === "positive" &&
                                            "icon-circle-check"
                                        ],
                                        attrs: { "data-testid": "icon" }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" " + _vm._s(_vm.title) + " ")
                            ]
                          }),
                          _vm.hasCloseBtn
                            ? _c("ButtonIcon", {
                                staticClass: "popover__close-btn",
                                attrs: {
                                  variant: "topRight",
                                  iconClassName: "icon-remove",
                                  "data-testid": "close-btn"
                                },
                                on: { click: _vm.onClose }
                              })
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm.hasDivider
                        ? _c("Divider", {
                            staticClass: "popover__divider",
                            attrs: { variant: "horizontal" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "popover__body" },
                [_vm._t("popoverBody")],
                2
              ),
              _vm.$slots.popoverFooter !== undefined
                ? _c(
                    "footer",
                    { staticClass: "popover__footer" },
                    [_vm._t("popoverFooter")],
                    2
                  )
                : _vm._e(),
              _c("div", { ref: "arrow", staticClass: "popover__arrow" }),
              _vm.mounted &&
              _vm.visibleActive &&
              _vm.currentPopoverRef !== undefined
                ? _c("PopperPosition", {
                    attrs: {
                      trackedRefName: _vm.trackedRef,
                      popoverRefName: _vm.currentPopoverRef,
                      arrowRefName: _vm.$refs.arrow,
                      placement: _vm.placement,
                      popperVisible:
                        _vm.mounted &&
                        _vm.visibleActive &&
                        _vm.currentPopoverRef !== undefined,
                      modifiers: _vm.popperModifiers,
                      trackerWatch: _vm.trackedRefName,
                      strategy: _vm.positionStrategy
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }